import React, { Component, useState} from 'react'
import { ethers } from "ethers"
import { ABI, CONTRACT_ADDRESS } from "../constant/index"

export default class WitchForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      amount: 1,
    }
  }
  onChange = event => {
    this.setState({
      amount: event.target.value,
    })
  }

  handleSubmit = async event => {
    event.preventDefault()
    try {
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        await provider.send("eth_requestAccounts", []);
        const contractSigner = provider.getSigner();
        const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, contractSigner)
        const ethValue = Number(this.state.amount) * 0.0666 
        console.log(ethValue.toString())

        const txParamsOverride = {
          value: ethers.utils.parseEther(ethValue.toString()),
        }

        const tx = await contract.mintWitch(
        Number(this.state.amount),
        txParamsOverride
        )
    } catch (error) {
      alert("Insufficient balance.");
      console.error(error)
    }
  }

  render() {
    return (
      <div className="container">
        <form onSubmit={this.handleSubmit} class="mint-form-container">
          <label>
            <span class="mint-amount">Amount:</span>
            <input
              class="mint-input-container"
              type="number"
              name="amount"
              onChange={this.onChange}
              value={this.state.amount}
              placeholder="1-25"
              NumericInput
              min={1}
              max={25}
              required
            />
            <button 
              class="mint-button"
              type="submit"
              onClick={this.handleSubmit}
            >
              Mint Your Witches
            </button>
          </label>
        </form>
      </div>
    )
  }

}